__turbopack_context__.v({
  "column": "PlaceholderServiceServiceRequest-module-scss-module__TXmZ5q__column",
  "columns": "PlaceholderServiceServiceRequest-module-scss-module__TXmZ5q__columns",
  "columnsSingle": "PlaceholderServiceServiceRequest-module-scss-module__TXmZ5q__columnsSingle",
  "cta": "PlaceholderServiceServiceRequest-module-scss-module__TXmZ5q__cta",
  "description": "PlaceholderServiceServiceRequest-module-scss-module__TXmZ5q__description",
  "header": "PlaceholderServiceServiceRequest-module-scss-module__TXmZ5q__header",
  "icon": "PlaceholderServiceServiceRequest-module-scss-module__TXmZ5q__icon",
  "inner": "PlaceholderServiceServiceRequest-module-scss-module__TXmZ5q__inner",
  "intro": "PlaceholderServiceServiceRequest-module-scss-module__TXmZ5q__intro",
  "section": "PlaceholderServiceServiceRequest-module-scss-module__TXmZ5q__section",
  "title": "PlaceholderServiceServiceRequest-module-scss-module__TXmZ5q__title",
});
